import { useEffect, useRef } from "react";
import { twMerge } from "tailwind-merge";
import Zoomist from "zoomist";

export function ZoomistWrapper({
  children,
  className,
}: React.PropsWithChildren<{ className?: string }>) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    new Zoomist(containerRef.current, {
      maxScale: 10,
      bounds: true,
      zoomRatio: 0.15,
    });
  }, []);

  return (
    <div
      ref={containerRef}
      className={twMerge(["zoomist-container w-full h-full", className])}
    >
      <div className="zoomist-wrapper">
        <div className="zoomist-image">{children}</div>
      </div>
    </div>
  );
}
